import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
}: SEOHeadProps) {
  const fullTitle = title.includes('SM专业指南')
    ? title
    : `${title} - SM专业指南`;
  const imageUrl =
    ogImage ||
    'https://readdy.ai/api/search-image?query=SM%20knowledge%20guide%20educational%20website%20with%20warm%20amber%20and%20cream%20tones%2C%20abstract%20educational%20illustration%2C%20clean%20modern%20aesthetic%2C%20soft%20natural%20lighting%2C%20editorial%20quality&width=1200&height=630&seq=seo-og-default&orientation=landscape';

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);
    const linkEl = document.querySelector('link[rel="canonical"]');
    if (linkEl) {
      linkEl.setAttribute('href', canonicalUrl);
    } else {
      const newLink = document.createElement('link');
      newLink.setAttribute('rel', 'canonical');
      newLink.setAttribute('href', canonicalUrl);
      document.head.appendChild(newLink);
    }

    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:image', imageUrl, true);
    setMeta('og:locale', 'zh_CN', true);
    setMeta('og:site_name', 'SM专业指南', true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    setMeta('twitter:image', imageUrl);
  }, [fullTitle, description, keywords, canonicalUrl, ogType, imageUrl]);

  return null;
}